import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import TwoFactorRecoveryVerifyForm from './TwoFactorRecoveryVerifyForm';
import { sendTwoFactorSupportEmail, resendTwoFactorRecoveryEmail, updateVerifyCompanyAndDomain, updateVerifyLastLoginWhen, updateVerifyLastLoginWhere, updateVerifyPhoneNumber, updateVerifyUsualLoginHow, updateVerifyUsualLoginWhere, verifyRecoveryToken } from '../../actions/twoFactorRecovery';
import { formSubmittable, getFormResponses, getEmailedSupport, getEmailSupportExpired, getVerifyCompanyAndDomain, getVerifyLastLoginWhen, getVerifyLastLoginWhere, getVerifyPhoneNumber, getVerifyUsualLoginHow, getVerifyUsualLoginWhere, getIsEmailingSupport, getVerificationExpired, getVerified, getEmailSupportAttempted, getVerificationAttempted, getIsRecoveryEmailToSupportInErrorState, getRecoveryNeedsSupport, getRecoveryAttempted, getRecoverySent
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
} from '../../selectors/TwoFactorRecovery';
import { parse as parseQuery } from 'hub-http/helpers/params';
import { jsx as _jsx } from "react/jsx-runtime";
const _TwoFactorRecoveryVer = TwoFactorRecoveryVerifyForm.propTypes,
  TwoFactorRecoveryVerifyFormPropTypes = Object.assign({}, (_objectDestructuringEmpty(_TwoFactorRecoveryVer), _TwoFactorRecoveryVer));

/*
(ts-migrate) TODO: Migrate the remaining prop types
...TwoFactorRecoveryVerifyFormPropTypes
*/

class TwoFactorRecoveryVerifyPage extends Component {
  constructor(...args) {
    super(...args);
    this.getToken = () => {
      const {
        search
      } = this.props.location;
      const query = parseQuery(search.substr(1));
      const {
        token
      } = query;
      return token;
    };
    this.handleRestart = () => {
      this.props.history.push('/');
    };
    this.handleSubmit = event => {
      event.preventDefault();
      const {
        formResponses
      } = this.props;
      const token = this.getToken();
      this.props.sendTwoFactorSupportEmail(token, formResponses);
    };
    this.handleResendRecoveryEmail = () => {
      const token = this.getToken();
      this.props.resendTwoFactorRecoveryEmail(token);
    };
  }
  componentDidMount() {
    const token = this.getToken();
    if (token === undefined) {
      this.props.history.push('/');
    } else {
      this.props.verifyRecoveryToken(token);
    }
  }
  render() {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "TWO_FACTOR_RECOVERY_VERIFY_LOAD",
      children: /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        alignSelf: "center",
        justifyContent: "center",
        flexDirection: "column",
        paddingBlockStart: "500",
        children: /*#__PURE__*/_jsx(View, {
          maxInlineSize: "500px",
          children: /*#__PURE__*/_jsx(TwoFactorRecoveryVerifyForm, Object.assign({
            onRestart: this.handleRestart,
            onSubmit: this.handleSubmit,
            onResendRecoveryEmail: this.handleResendRecoveryEmail
          }, this.props))
        })
      })
    });
  }
}
TwoFactorRecoveryVerifyPage.propTypes = Object.assign({}, TwoFactorRecoveryVerifyFormPropTypes, {
  formResponses: PropTypes.object,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  sendTwoFactorSupportEmail: PropTypes.func.isRequired,
  resendTwoFactorRecoveryEmail: PropTypes.func.isRequired,
  verifyRecoveryToken: PropTypes.func.isRequired
});
const mapStateToProps = state => ({
  emailedSupport: getEmailedSupport(state),
  emailSupportAttempted: getEmailSupportAttempted(state),
  emailSupportExpired: getEmailSupportExpired(state),
  formCompanyAndDomain: getVerifyCompanyAndDomain(state),
  formLastLoginWhen: getVerifyLastLoginWhen(state),
  formLastLoginWhere: getVerifyLastLoginWhere(state),
  formPhoneNumber: getVerifyPhoneNumber(state),
  formResponses: getFormResponses(state),
  formSubmittable: formSubmittable(state),
  formUsualLoginHow: getVerifyUsualLoginHow(state),
  formUsualLoginWhere: getVerifyUsualLoginWhere(state),
  isEmailingSupport: getIsEmailingSupport(state),
  isRecoveryEmailInErrorState: getIsRecoveryEmailToSupportInErrorState(state),
  recoveryAttempted: getRecoveryAttempted(state),
  recoveryNeedsSupport: getRecoveryNeedsSupport(state),
  recoverySent: getRecoverySent(state),
  verificationAttempted: getVerificationAttempted(state),
  verificationExpired: getVerificationExpired(state),
  verified: getVerified(state)
});
const reduxConnect = connect(mapStateToProps, {
  sendTwoFactorSupportEmail,
  resendTwoFactorRecoveryEmail,
  onFormCompanyAndDomainChange: updateVerifyCompanyAndDomain,
  onFormLastLoginWhenChange: updateVerifyLastLoginWhen,
  onFormLastLoginWhereChange: updateVerifyLastLoginWhere,
  onFormPhoneNumberChange: updateVerifyPhoneNumber,
  onFormUsualLoginHowChange: updateVerifyUsualLoginHow,
  onFormUsualLoginWhereChange: updateVerifyUsualLoginWhere,
  verifyRecoveryToken
});
export default reduxConnect(TwoFactorRecoveryVerifyPage);